import { TaskAbort, TaskError, TaskStatus } from '../../types/video/Task';
import isAbortError from '../isAbortError';

function createTaskError(error: Error): TaskError | TaskAbort {
  return isAbortError(error)
    ? { status: TaskStatus.Aborted }
    : { status: TaskStatus.Error, error: error.message };
}

export default createTaskError;
